class HHMaterialsCarousel extends HTMLElement {
  constructor() {
    super()

    this.mainGallery = null;
    this.sectionId = this.getAttribute('data-section-id');
    this.swiperSelector = `[data-section-id='${this.sectionId}'] .swiper`;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.mainGallery = new Swiper(this.swiperSelector, {
      spaceBetween: 20,
      slidesPerView: 1.4,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      breakpoints: {
        990: {
          centerInsufficientSlides: true,
          slidesPerView: 5,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        }
      },
    });
  }
}

customElements.define('hh-materials-carousel', HHMaterialsCarousel)
